import {
  Box,
  Grid,
  Button,
  IconButton,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormHelperText,
  CircularProgress,
} from "@mui/material";
import { useState, useEffect } from "react";
import TextFieldInput from "../../../components/TextFieldInput";
import UploadInput from "../../../components/UploadInput";
import UploadPopup from "../../../shared-components/upload-popup/UploadPopup";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import { useDispatch, useSelector } from "react-redux";
import { removeBlobImages } from "../../../utilis/common-funtions";
import deleteIcon from "../../../assets/icons/delete-red.svg";
import { useRazorpayPayment } from "../../voucher-form/components/payments/useRazorpayPayment";
import { formatDateIST } from "../../voucher-form/components/common-functions/PaymentCommonFunctions";
import { useParams } from "react-router-dom";
import PaymentCard from "../../voucher-form/components/thank-you/PaymentCard";
import CustomDatePicker from "../../../components/CustomDatePicker";
import {
  CorporateFinanceStatus,
  CorporatePaymentMode,
  EOIFinanceStatus,
  GATEWAY,
  getStatusStyles,
  MAX_TRANSACTION_LIMIT,
  OFFLINE_PAYMENT_METHODS,
  PAYMENT_ENTITY_TYPE,
} from "../../../config/constant";
import { createRazorpayOrder, verifyVoucherPayment } from "../../voucher-form/voucher-form.slice";
import { useTranslation } from "react-i18next";
import SnackbarAlert from "../../../shared-components/snackbar-alert/SnackbarAlert";
import { deletePaymentDetails } from "../new-booking-form.slice";
import { useEasebuzzPayment } from "../../voucher-form/components/payments/useEasebuzzPayment";
import PaymentFailedModal from "../Individual-components/PaymentFailedModal";
const CorporatePaymentOptionsForm = ({ paymentOptionsFormik, totalAmount, useFullPayableForNewTransaction = false }) => {
  const { t } = useTranslation("common", {
    keyPrefix: "corporatePaymentOption",
  });
  const { oppId } = useParams();
  const [paymentIndex, setPaymentIndex] = useState("");
  const dispatch = useDispatch();

  const { applicantData } = useSelector(
    (state) => state?.newBookingForm
  );
  const { projectId } = useSelector((state) => state.newBookingForm);
  const TOTAL_BOOKING_AMOUNT = totalAmount;

  const [verifying, setVerifying] = useState(false);
  const [payButtonLoading, setPayButtonLoading] = useState(false);
  const [snackbarConfig, setSnackbarConfig] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const [imageState, setImageState] = useState([
    {
      id: "",
      paymentMethod: CorporatePaymentMode.GATEWAY, // online | offline
      offlineRadioOptions: "", // cheque/fundtransfer/card/edcMachine
      transactionNo: "",
      bankName: "",
      branchName: "",
      accountNo: "",
      amount: TOTAL_BOOKING_AMOUNT,
      onlineAmount: TOTAL_BOOKING_AMOUNT,
      paymentProof: [],
      status: CorporateFinanceStatus.UNVERIFIED, // pending | success
      date: null,
      type: "",
      isPaid: false,
      showUploadPopup: false,
      isPhysicalPaymentProof: false,
      email: "",
      onlineMethod: "",
      contact: "",
      orderId: "",
      gatewayPaymentId: "",
      paymentTransactionId: "",
    },
  ]);
  const [openPaymentFailedModal, setOpenPaymentFailedModal] = useState(false);
  const [failedAmount, setFailedAmount] = useState("");
  const [failedGatewayForRetry, setFailedGatewayForRetry] = useState(null);

  const availableGateways = applicantData?.project?.availableGateways ?? [GATEWAY.EASEBUZZ,GATEWAY.RAZORPAY];
  const hasOnlyRazorpay =
    Array.isArray(availableGateways) &&
    availableGateways.length === 1 &&
    availableGateways.includes(GATEWAY.RAZORPAY);
  const hasOnlyEasebuzz =
    Array.isArray(availableGateways) &&
    availableGateways.length === 1 &&
    availableGateways.includes(GATEWAY.EASEBUZZ);
  const {
    initiatePayment,
    paymentResponse,
  } = useRazorpayPayment();

  const { initiateEasebuzzPayment, paymentResponse: easebuzzPaymentResponse } =
    useEasebuzzPayment();

  const { values, setFieldValue } = paymentOptionsFormik;

  const commonOfflinePaymentFields = {
    firstField: {
      label: t("paymentOptionForm.commonFields.transactionNumber.label"),
      placeholder: t(
        "paymentOptionForm.commonFields.transactionNumber.placeholder",
      ),
    },
    secondField: {
      label: "Bank Name",
      placeholder: "Enter Bank Name",
    },
    thirdField: {
      label: "Branch Name",
      placeholder: "Enter Branch Name",
    },
    fourthField: {
      label: "Account Number",
      placeholder: "Enter Account Number",
    },
  };

  const handleSnackbarClose = () => {
    setSnackbarConfig({
      open: false,
      message: "",
      severity: "",
    });
  };
  const handleImageValue = (txnIndex, keyName, imgName, close) => {
    removeBlobImages();
    
    const allTransactions = [...values.transactions];
    allTransactions[txnIndex] = {
      ...allTransactions[txnIndex],
      [keyName]: [...imgName],
      showUploadPopup: false,
      isPhysicalPaymentProof: false, // append new
    };
    setImageState(allTransactions);
  };

  const handlePhysicalImage = (txnIndex, keyName, value) => {
    const allTransactions = [...values.transactions];
    allTransactions[txnIndex] = {
      ...allTransactions[txnIndex],
      isPhysicalPaymentProof: value,
      showUploadPopup: false, // close popup after setting physical proof
    };
    setImageState(allTransactions);
  };

  useEffect(() => {
    paymentOptionsFormik.setFieldValue("transactions", imageState);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imageState]);

  const handleUpdateImageData = (index, fieldName, imageData) => {
    setFieldValue(`transactions[${index}].paymentProof`, imageData);
    paymentOptionsFormik.setFieldValue(
      `transactions[${index}].paymentProof`,
      imageData
    );
  };

  const toggleTransactionScreenshot = (index) => {
    const updated = [...values.transactions];
    updated[index].showUploadPopup = !updated[index].showUploadPopup;
    setFieldValue("transactions", updated);
  };


  const handleRazorPay = async (amount, index) => {
    setPaymentIndex(index);
    const payload = {
      amount: amount,
      entityType: PAYMENT_ENTITY_TYPE.BOOKING,
      entityId: applicantData?.id?.toString(),
      projectId: projectId?.toString(),

      gateway: GATEWAY?.RAZORPAY,
      notes: {
        opportunityId: oppId,
        bookingAmount: TOTAL_BOOKING_AMOUNT,
        productInfo: oppId,
        guest: {
          name: `${applicantData?.applicant1?.personalDetails?.firstName} ${applicantData?.applicant1?.personalDetails?.lastName}`.trim(),
          email:
            applicantData?.applicant1?.personalDetails?.emailAddress ||
            applicantData?.applicant1?.contactDetails?.emailAddress,
          phone:
            applicantData?.applicant1?.personalDetails?.contactNumber ||
            applicantData?.applicant1?.contactDetails?.contactNumber,
        },
      },
    };

    try {
      const orderRes = await dispatch(createRazorpayOrder(payload)).unwrap();
      if (orderRes) {
        setPayButtonLoading(false);
      }
      initiatePayment({
        amount: orderRes?.razorpayOrder?.amount,
        currency: orderRes?.razorpayOrder?.currency,
        orderId: orderRes?.razorpayOrder?.id,
        name: "Puravankara",
        description: "Payment",
        prefill: {
          name: orderRes?.razorpayOrder?.notes?.guest?.name,
          email: orderRes?.razorpayOrder?.notes?.guest?.email,
          contact: orderRes?.razorpayOrder?.notes?.guest?.phone,
        },
        razorpayKey: orderRes?.razorpayKey,
        originalAmount: amount,
        onFailure: (amt) => {
          setFailedAmount(amt);
          setOpenPaymentFailedModal(true);
          setFailedGatewayForRetry(hasOnlyRazorpay ? GATEWAY?.RAZORPAY : null);
        },
      });
    } catch (err) {
      console.error("Payment failed:", err);
      setPayButtonLoading(false);
      setFailedAmount(amount);
      setOpenPaymentFailedModal(true);
      setFailedGatewayForRetry(hasOnlyRazorpay ? GATEWAY?.RAZORPAY : null);
    }
  };

  const handleEasebuzzPay = async (amount, index) => {
    setPaymentIndex(index);
    setPayButtonLoading(true);
    try {
      const orderRes = await dispatch(
        createRazorpayOrder({
          amount,
          entityType: PAYMENT_ENTITY_TYPE.BOOKING,
          entityId: applicantData?.id?.toString(),
          projectId: projectId?.toString(),
          gateway: GATEWAY?.EASEBUZZ,
          productInfo: PAYMENT_ENTITY_TYPE.BOOKING,
          redirectUrl: window.location.href,
          notes: {
            opportunityId: oppId,
            bookingAmount: TOTAL_BOOKING_AMOUNT,
            guest: {
              name: `${applicantData?.applicant1?.personalDetails?.firstName} ${applicantData?.applicant1?.personalDetails?.lastName}`,
              email:
                applicantData?.applicant1?.personalDetails?.emailAddress ||
                applicantData?.applicant1?.contactDetails?.emailAddress,
              phone:
                applicantData?.applicant1?.personalDetails?.contactNumber ||
                applicantData?.applicant1?.contactDetails?.contactNumber,
            },
          },
        })
      ).unwrap();

      if (orderRes) {
        setPayButtonLoading(false);
      }

      const orderAccessKey = orderRes.accessKey;

      if (!orderAccessKey) {
        throw new Error(
          "Backend did not return access_key. Check createRazorpayOrder response: " +
            JSON.stringify(orderRes)
        );
      }

      await initiateEasebuzzPayment({
        orderAccessKey,
        easebuzzKey: orderRes?.easebuzzKey,
        originalAmount: amount,
        onModalClose: (amt) => {
          setFailedAmount(amt);
          setOpenPaymentFailedModal(true);
          setFailedGatewayForRetry(hasOnlyEasebuzz ? GATEWAY?.EASEBUZZ : null);
        },
      });
      setPayButtonLoading(false);
    } catch (err) {
      setFailedAmount(amount);
      setOpenPaymentFailedModal(true);
      setFailedGatewayForRetry(hasOnlyEasebuzz ? GATEWAY?.EASEBUZZ : null);
      setPayButtonLoading(false);
      console.error("Failed to initiate payment:", err);
    }
  };
  
  useEffect(() => {
    if (!paymentResponse) return;

    let attempts = 0;
    let isVerified = false;
    setFailedAmount('');

    const verifyPayment = async () => {
      if (attempts === 0) setVerifying(true); // start loading
      attempts++;

      try {
        const res = await dispatch(
          verifyVoucherPayment({
            orderId: paymentResponse?.razorpay_order_id,
            paymentId: paymentResponse?.razorpay_payment_id,
            signature: paymentResponse?.razorpay_signature,
            gateway: GATEWAY?.RAZORPAY,
            clientResponse: JSON.stringify(paymentResponse)
          })
        );
        if (res?.payload?.status === "success") {

          isVerified = true;
          handlePaymentResponse(
            paymentIndex,
            res?.payload?.method,
            res?.payload?.date,
            res?.payload?.gatewayPaymentId
          );
          setVerifying(false); // stop loading on success
        } else if (attempts < 3 && !isVerified) {
          console.error("Payment verification failed, retrying...", {
            attempt: attempts,
            error: res?.error || res?.payload?.error || res?.payload,
          });
          setTimeout(verifyPayment, 5000); // retry after short delay
        } else {
          console.error("Payment verification failed after retries", {
            attempts,
            error: res?.error?.payload?.errors?.message || res?.payload,
          });
          setVerifying(false);
          setFieldValue(
            `transactions[${paymentIndex}].status`,
            EOIFinanceStatus.UNVERIFIED
          );
          const amt = values?.transactions?.[paymentIndex]?.amount;
          setFailedAmount(amt);
          setOpenPaymentFailedModal(true);
          setFailedGatewayForRetry(hasOnlyRazorpay ? GATEWAY?.RAZORPAY : null);
        }
      } catch (err) {
        console.error("Unexpected exception in verifyPayment", err);
        setVerifying(false);
        setFieldValue(
          `transactions[${paymentIndex}].status`,
          EOIFinanceStatus.UNVERIFIED
        );
        const amt = values?.transactions?.[paymentIndex]?.amount;
        setFailedAmount(amt);
        setOpenPaymentFailedModal(true);
        setFailedGatewayForRetry(hasOnlyRazorpay ? GATEWAY?.RAZORPAY : null);
      }
    };

    verifyPayment();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentResponse]);

   useEffect(() => {
      if (!easebuzzPaymentResponse) return;
  
      if (easebuzzPaymentResponse && easebuzzPaymentResponse?.status === "failure") {
        setFailedAmount(easebuzzPaymentResponse?.amount);
        setOpenPaymentFailedModal(true);
        setFailedGatewayForRetry(hasOnlyEasebuzz ? GATEWAY?.EASEBUZZ : null);
        return;
      }
      let attempts = 0;
      let isVerified = false;
       setFailedAmount('');
  
      const verifyPayment = async () => {
        if (attempts === 0) setVerifying(true); // start loading
        attempts++;
  
        const res = await dispatch(
          verifyVoucherPayment({
            orderId: easebuzzPaymentResponse?.txnid,
            paymentId: easebuzzPaymentResponse?.easepayid,
            signature: easebuzzPaymentResponse?.hash,
            gateway: GATEWAY?.EASEBUZZ,
            clientResponse: JSON.stringify(easebuzzPaymentResponse)
          })
        );
  
        if (res?.payload?.status === "success") {
          isVerified = true;
          handlePaymentResponse(
            paymentIndex,
            res?.payload?.method,
            res?.payload?.date,
            res?.payload?.gatewayPaymentId
          );
          setVerifying(false); // stop loading on success
        } else if (attempts < 3 && !isVerified) {
          // retry after short delay
          setTimeout(verifyPayment, 2000);
        } else {
          setVerifying(false);
          setFieldValue(
            `transactions[${paymentIndex}].status`,
            "Verification Failed"
          );
          setFailedAmount(values?.transactions?.[paymentIndex]?.amount);
          setOpenPaymentFailedModal(true);
          setFailedGatewayForRetry(hasOnlyEasebuzz ? GATEWAY?.EASEBUZZ : null);
        }
      };
      if (easebuzzPaymentResponse && easebuzzPaymentResponse?.status === "success") {
        verifyPayment();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [easebuzzPaymentResponse]);
    

  const handlePaymentResponse = (index, method, date, paymentId) => {
    
    setFieldValue(`transactions[${index}].isPaid`, true);
    setFieldValue(
      `transactions[${index}].status`,
      CorporateFinanceStatus.VERIFIED
    );
    setFieldValue(`transactions[${index}].date`, date);
    setFieldValue(`transactions[${index}].onlineMethod`, method);
    setFieldValue(`transactions[${index}].gatewayPaymentId`, paymentId);
  };

  const getLabel = (option) => {
    switch (option) {
      case OFFLINE_PAYMENT_METHODS.CHEQUE:
        return {
          firstField: {
            label: t("paymentOptionForm.cheque.firstField.label"),
            placeholder: t("paymentOptionForm.cheque.firstField.placeholder"),
          },
          secondField: {
            label: t("paymentOptionForm.commonFields.bankName.label"),
            placeholder: t(
              "paymentOptionForm.commonFields.bankName.placeholder"
            ),
          },
          thirdField: {
            label: t("paymentOptionForm.commonFields.bankName.label"),
            placeholder: "Enter Branch Name",
          },
          fourthField: {
            label: "Enter Account Number",
            placeholder: "Enter Account Number",
          },
        };
      case OFFLINE_PAYMENT_METHODS.ONLINETRANSFER:
        return {
          firstField: {
            label: t("paymentOptionForm.commonFields.transactionNumber.label"),
            placeholder: t(
              "paymentOptionForm.commonFields.transactionNumber.placeholder"
            ),
          },
          secondField: {
            label: t("paymentOptionForm.commonFields.bankName.label"),
            placeholder: t(
              "paymentOptionForm.commonFields.bankName.placeholder"
            ),
          },
          thirdField: {
            label: "Enter Branch Name",
            placeholder: "Enter Branch Name",
          },
          fourthField: {
            label: "Enter Account Number",
            placeholder: "Enter Account Number",
          },
        };
      case OFFLINE_PAYMENT_METHODS.UPI_CARD:
      case OFFLINE_PAYMENT_METHODS.EDC_MACHINE:
      default:
        return commonOfflinePaymentFields;
    }
  };

  const handleAddTransaction = () => {
    if (
      paymentOptionsFormik?.values?.transactions?.length >=
      MAX_TRANSACTION_LIMIT
    )
      return;

    const total = totalAmount > 0 ? Number(totalAmount) : 0;
    const currentSum = Number(CalculateSum()) > 0 ? Number(CalculateSum()) : 0;
    const onlineValue = useFullPayableForNewTransaction
      ? total
      : (total - currentSum > 0 ? total - currentSum : 0);

    setFieldValue("transactions", [
      ...values.transactions,
      {
        id: "",
        paymentMethod: CorporatePaymentMode.GATEWAY, // online | offline
        offlineRadioOptions: "", // cheque/fundtransfer/card/edcMachine
        transactionNo: "",
        bankName: "",
        branchName: "",
        accountNo: "",
        amount: onlineValue,
        onlineAmount:  onlineValue,
        paymentProof: [],
        status: CorporateFinanceStatus.UNVERIFIED, // pending | success
        date: null,
        type: "",
        isPaid: false,
        showUploadPopup: false,
        isPhysicalPaymentProof: false,
        email: "",
        onlineMethod: "",
        contact: "",
        orderId: "",
        gatewayPaymentId: "",
        paymentTransactionId: "",
      },
    ]);
  };

  const handleRemoveTransaction = (index, id) => {
    const updated = [...values.transactions];
    updated.splice(index, 1);
    if (id) {
      dispatch(
        deletePaymentDetails({
          opportunityId: oppId,
          paymentId: id,
        })
      )
        .unwrap() // gives direct access to fulfilled/rejected values
        .then((res) => {
          if (res.success) {
            setFieldValue("transactions", updated);
          }
        })
        .catch((err) => {
          console.error("Delete failed:", err);
        });
    } else {
      setFieldValue("transactions", updated);
    }
  };

  const handleInputFilter = (e, index, key, type) => {
    let value = e?.target?.value || "";

    switch (type) {
      case "alphanumeric": // cheque/dd/txn no.
        value = value.replace(/[^a-zA-Z0-9]/g, "");
        break;
      case "alphabets": // bank & branch names
        value = value.replace(/[^a-zA-Z ]/g, "");
        break;
      case "numbers": // account no. & amount
        value = value.replace(/[^0-9]/g, "");
        break;
      default:
        break;
    }

    const updateArray = structuredClone(
      paymentOptionsFormik?.values?.transactions
    );

    updateArray[index][key] = value;

    paymentOptionsFormik.setFieldValue("transactions", updateArray);
  };

  function CalculateSum() {
    const sum = values?.transactions?.reduce(
      (acc, txn) => acc + (Number(txn.amount) || 0),
      0
    );
    return sum;
  }

  function getTransactionTitle(index) {
    if (applicantData?.paymentDetails && index === 0) {
      return true;
    } else if (values?.transactions?.length > 1 && index === 0) {
      return true;
    } else if (index === 0) {
      return false;
    } else {
      return true;
    }
  }

  const handleProceedGateway = (selectedGateway) => {
    if (selectedGateway === GATEWAY?.RAZORPAY) {
      handleRazorPay(failedAmount, paymentIndex);
      setFailedAmount("");
    }
    if (selectedGateway === GATEWAY?.EASEBUZZ) {
      handleEasebuzzPay(failedAmount, paymentIndex);
      setFailedAmount("");
    }
    setOpenPaymentFailedModal(false);
    setFailedGatewayForRetry(null);
  };

  const handleClosePaymentFailedModal = () => {
    setOpenPaymentFailedModal(false);
    setFailedGatewayForRetry(null);
  };

  return (
    <>
      {/* If no transactions, show Add Button */}
      {values?.transactions?.length === 0 && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: "8px",
            color: "rgba(26, 64, 125, 1)",
          }}
        >
          <Button onClick={handleAddTransaction}>
            <ControlPointIcon sx={{ color: "rgba(26, 64, 125, 1)" }} />
            <Typography
              sx={{
                color: "rgba(26, 64, 125, 1)",
                fontSize: "14px",
                fontWeight: "600",
                textDecoration: "underline",
                textTransform: "none",
              }}
            >
              {t("paymentOptionForm.multipleTransactionButton")}
            </Typography>
          </Button>
        </Box>
      )}

      {/* {applicantData?.primarySource ? (
        <Grid container spacing={2} mb={2} ml={0}>
          <Grid item xs={6}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
                Primary Source: &nbsp;
              </Typography>
              <Typography sx={{ fontSize: "14px" }}>
                {applicantData?.primarySource}
              </Typography>
            </Box>
          </Grid>
          {applicantData?.sourceDetails?.referredBy && (
            <Grid item xs={6}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
                  Referred By: &nbsp;
                </Typography>
                <Typography sx={{ fontSize: "14px" }}>
                  {applicantData?.sourceDetails?.referredBy}
                </Typography>
              </Box>
            </Grid>
          )}
          {applicantData?.sourceDetails?.channelPartner && (
            <Grid item xs={6}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
                  CP Name: &nbsp;
                </Typography>
                <Typography sx={{ fontSize: "14px" }}>
                  {applicantData?.sourceDetails?.channelPartner}
                </Typography>
              </Box>
            </Grid>
          )}
          {applicantData?.sourceDetails?.employeeName && (
            <Grid item xs={6}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
                  Employee Name: &nbsp;
                </Typography>
                <Typography sx={{ fontSize: "14px" }}>
                  {applicantData?.sourceDetails?.employeeName}
                </Typography>
              </Box>
            </Grid>
          )}
        </Grid>
      ) : null} */}

      {values?.transactions?.map((txn, index) => {
        const isDisabled =
          txn?.paymentMethod === CorporatePaymentMode.OFFLINE &&
          txn?.status === CorporatePaymentMode.VERIFIED;
        const { bg, color, text } = getStatusStyles(txn?.status);
        return (
          <Box
            key={index}
            sx={{
              borderRadius: "12px",
              padding: "16px",
              marginBottom: "20px",
              position: "relative",
              border: "1px solid rgba(26, 64, 125, 0.3)",
            }}
          >
            {/* Delete Transaction */}
            {getTransactionTitle(index) && (
              <Grid container spacing={2} mb={3}>
                <Grid item xs={6}>
                  <Typography sx={{ fontSize: "14px", fontWeight: "700" }}>
                    Transaction {index + 1}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  {!txn?.isPaid && index !== 0 && (
                    <IconButton
                      onClick={() => handleRemoveTransaction(index, txn.id)}
                      sx={{
                        position: "absolute",
                        top: 45,
                        right: 8,
                      }}
                      disabled={txn?.isPaid}
                    >
                      <img
                        src={deleteIcon}
                        alt=""
                        style={{ height: "24px", width: "24px" }}
                      />
                    </IconButton>
                  )}
                  {txn?.id &&
                    txn.paymentMethod !== CorporatePaymentMode.GATEWAY && (
                      <Box
                        sx={{
                          backgroundColor: bg,
                          color,
                          borderRadius: "6px",
                          px: 1.5,
                          py: 0.5,
                          fontWeight: 700,
                          fontSize: "14px",
                          mt: 1,
                          // mr: 5,
                          position: "absolute",
                          top: 8,
                          right: 8,
                        }}
                      >
                        {text}
                      </Box>
                    )}
                </Grid>
              </Grid>
            )}

            {/* Payment Method Options */}
            {!txn?.isPaid && !txn.id && (
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                    {t("paymentOptionForm.selectPaymentMethod")}
                    <span className="asteriskColor"> *</span>
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Box
                    onClick={() =>
                      setFieldValue(
                        `transactions[${index}].paymentMethod`,
                        CorporatePaymentMode.GATEWAY
                      )
                    }
                    sx={{
                      width: "100%",
                      border:
                        txn.paymentMethod === CorporatePaymentMode.GATEWAY
                          ? "rgba(0, 54, 140, 1)"
                          : "1px solid rgba(208, 213, 221, 1)",
                      textAlign: "center",
                      height: "42px",
                      borderRadius: "8px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor:
                        txn.paymentMethod === CorporatePaymentMode.GATEWAY
                          ? "rgba(26, 64, 125, 1)"
                          : "",
                      color:
                        txn.paymentMethod === CorporatePaymentMode.GATEWAY
                          ? "#fff"
                          : "#1A407D",
                      fontWeight: 500,
                      cursor: "pointer",
                    }}
                  >
                    {t("paymentOptionForm.payNow")}
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Box
                    onClick={() =>
                      setFieldValue(
                        `transactions[${index}].paymentMethod`,
                        CorporatePaymentMode.OFFLINE
                      )
                    }
                    sx={{
                      width: "100%",
                      border:
                        txn.paymentMethod === CorporatePaymentMode.OFFLINE
                          ? "rgba(0, 54, 140, 1)"
                          : "1px solid rgba(208, 213, 221, 1)",
                      textAlign: "center",
                      height: "42px",
                      borderRadius: "8px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor:
                        txn.paymentMethod === CorporatePaymentMode.OFFLINE
                          ? "rgba(26, 64, 125, 1)"
                          : "",
                      color:
                        txn.paymentMethod === CorporatePaymentMode.OFFLINE
                          ? "#fff"
                          : "#1A407D",
                      fontWeight: 500,
                      cursor: "pointer",
                    }}
                  >
                    {t("paymentOptionForm.uploadPaymentDetails")}
                  </Box>
                </Grid>
              </Grid>
            )}
            <FormHelperText error>
              {paymentOptionsFormik?.touched?.transactions?.[index]
                ?.paymentMethod
                ? paymentOptionsFormik?.errors?.transactions?.[index]
                    ?.paymentMethod
                : ""}
            </FormHelperText>

            {txn.paymentMethod === CorporatePaymentMode.GATEWAY &&
              txn?.isPaid && (
                <PaymentCard
                  key={txn?.index}
                  amount={txn?.amount}
                  date={formatDateIST(txn?.date)}
                  method={txn?.onlineMethod?.toUpperCase()}
                  status={txn?.status}
                  transactionId={txn?.gatewayPaymentId}
                />
              )}

            {/* Online Payment Fields */}
            {txn.paymentMethod === CorporatePaymentMode.GATEWAY &&
              !txn?.isPaid && (
                <>
                <Grid item xs={12} mt={3}>
                  <Typography sx={{ fontSize: "14px" }}>
                    <span style={{ fontWeight: '500'}}>{t("paymentOptionForm.note")}:</span> {t("paymentOptionForm.noteMessage")}
                  </Typography>
                </Grid>
                <Grid container item xs={12} sm={6} spacing={2} mt={0}>
                  {/* Amount Input */}
                  <Grid item xs={12} sm={9}>
                    <TextFieldInput
                      field={{
                        name: `transactions[${index}].amount`,
                        label: t("paymentOptionForm.amount"),
                        required: true,
                        readonly: Boolean(txn?.isPaid),
                        placeholder: t("paymentOptionForm.enterAmount"),
                        maxLength: 15,
                        handleOnChange: (e) =>
                          handleInputFilter(e, index, "amount", "numbers"),
                        value: txn.amount || "",
                      }}
                      formik={paymentOptionsFormik}
                    />
                    <FormHelperText error>
                      {paymentOptionsFormik?.touched?.transactions?.[index]
                        ?.amount
                        ? paymentOptionsFormik?.errors?.transactions?.[index]
                            ?.amount
                        : ""}
                      {!paymentOptionsFormik?.errors?.transactions?.[index]
                        ?.amount &&
                      paymentOptionsFormik?.touched?.transactions?.[index]
                        ?.isPaid
                        ? paymentOptionsFormik?.errors?.transactions?.[index]
                            ?.isPaid
                        : ""}
                    </FormHelperText>
                  </Grid>

                  {/* Single Proceed CTA: only Razorpay → Razorpay; only Easebuzz or both → try Easebuzz first (on failure, modal offers Razorpay) */}
                  <Grid item xs={12} sm={3} mt={{ xs: 1, sm: 3.5 }}>
                    <Button
                      variant="contained"
                      size="large"
                      sx={{
                        backgroundColor: "rgba(26, 64, 125, 1)",
                        borderRadius: "8px",
                        color: "#fff",
                        textTransform: "none",
                        cursor: "pointer",
                        minWidth: "120px",
                        maxHeight: "44px",
                        "&:hover": {
                          backgroundColor: "#092552",
                          color: "#fff",
                        },
                      }}
                      onClick={() =>
                        hasOnlyRazorpay
                          ? handleRazorPay(txn.amount, index)
                          : handleEasebuzzPay(txn.amount, index)
                      }
                      disabled={txn?.isPaid || !txn.amount || txn?.amount <= 0}
                    >
                      {payButtonLoading ? (
                        <CircularProgress size={24} sx={{ color: "white" }} />
                      ) : (
                        t("paymentOptionForm.proceed")
                      )}
                    </Button>
                  </Grid>
                </Grid>
                </>
              )}

            {/* Offline Payment Fields */}
            {txn.paymentMethod === CorporatePaymentMode.OFFLINE && (
              <>
                <Grid item xs={12} mt={3}>
                  <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                    {t("paymentOptionForm.selectOfflinePaymentMethod")}
                    <span className="asteriskColor"> *</span>
                  </Typography>
                </Grid>
                <RadioGroup
                  name={`transactions[${index}].offlineRadioOptions`}
                  value={txn.offlineRadioOptions}
                  onChange={(e) =>
                    setFieldValue(
                      `transactions[${index}].offlineRadioOptions`,
                      e.target.value
                    )
                  }
                  sx={{ mt: 0, ml: 1 }}
                >
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
                    <FormControlLabel
                      value={OFFLINE_PAYMENT_METHODS.CHEQUE}
                      control={<Radio />}
                      label={t("paymentOptionForm.paymentMethods.cheque")}
                      sx={{
                        "& .MuiFormControlLabel-label": {
                          fontSize: "14px",
                          fontWeight: 400,
                        },
                      }}
                      disabled={isDisabled}
                    />
                    <FormControlLabel
                      value={OFFLINE_PAYMENT_METHODS.ONLINETRANSFER}
                      control={<Radio />}
                      label={t(
                        "paymentOptionForm.paymentMethods.onlineFundTransfer"
                      )}
                      sx={{
                        "& .MuiFormControlLabel-label": {
                          fontSize: "14px",
                          fontWeight: 400,
                        },
                      }}
                      disabled={isDisabled}
                    />
                    <FormControlLabel
                      value={OFFLINE_PAYMENT_METHODS.UPI_CARD}
                      control={<Radio />}
                      label={t("paymentOptionForm.paymentMethods.upicard")}
                      sx={{
                        "& .MuiFormControlLabel-label": {
                          fontSize: "14px",
                          fontWeight: 400,
                        },
                      }}
                      disabled={isDisabled}
                    />
                    <FormControlLabel
                      value={OFFLINE_PAYMENT_METHODS.EDC_MACHINE}
                      control={<Radio />}
                      label={t("paymentOptionForm.paymentMethods.edc")}
                      sx={{
                        "& .MuiFormControlLabel-label": {
                          fontSize: "14px",
                          fontWeight: 400,
                        },
                      }}
                      disabled={isDisabled}
                    />
                  </Box>
                </RadioGroup>
                <FormHelperText error>
                  {paymentOptionsFormik?.touched?.transactions?.[index]
                    ?.offlineRadioOptions
                    ? paymentOptionsFormik?.errors?.transactions?.[index]
                        ?.offlineRadioOptions
                    : ""}
                </FormHelperText>

                <Box>
                  {/* Transaction Details */}
                  <Grid container spacing={2} mt={0}>
                    <Grid item xs={12} sm={6}>
                      <TextFieldInput
                        field={{
                          name: `transactions[${index}].transactionNo`,
                          label: getLabel(txn.offlineRadioOptions)?.firstField
                            .label,
                          placeholder: getLabel(txn.offlineRadioOptions)
                            ?.firstField.placeholder,
                          required: true,
                          handleOnChange: (e) =>
                            handleInputFilter(
                              e,
                              index,
                              "transactionNo",
                              "alphanumeric"
                            ),
                          value: txn.transactionNo || "",
                          maxLength: 30,
                          readonly: isDisabled,
                        }}
                        formik={paymentOptionsFormik}
                      />
                      <FormHelperText error>
                        {paymentOptionsFormik?.touched?.transactions?.[index]
                          ?.transactionNo
                          ? paymentOptionsFormik?.errors?.transactions?.[index]
                              ?.transactionNo
                          : ""}
                      </FormHelperText>
                    </Grid>

                    {txn.offlineRadioOptions ===
                      OFFLINE_PAYMENT_METHODS.CHEQUE && (
                      <Grid item xs={12} sm={6}>
                        <TextFieldInput
                          field={{
                            name: `transactions[${index}].bankName`,
                            label: t(
                              "paymentOptionForm.commonFields.bankName.label"
                            ),
                            placeholder: t(
                              "paymentOptionForm.commonFields.bankName.placeholder"
                            ),
                            required: true,
                            handleOnChange: (e) =>
                              handleInputFilter(
                                e,
                                index,
                                "bankName",
                                "alphabets"
                              ),
                            value: txn.bankName || "",
                            maxLength: 50,
                            readonly: isDisabled,
                          }}
                          formik={paymentOptionsFormik}
                        />
                        <FormHelperText error>
                          {paymentOptionsFormik?.touched?.transactions?.[index]
                            ?.bankName
                            ? paymentOptionsFormik?.errors?.transactions?.[
                                index
                              ]?.bankName
                            : ""}
                        </FormHelperText>
                      </Grid>
                    )}
                    {/* {txn.offlineRadioOptions ===
                      OFFLINE_PAYMENT_METHODS.ONLINETRANSFER && (
                      <Grid item xs={12} sm={6}>
                        <TextFieldInput
                          field={{
                            name: `transactions[${index}].branchName`,
                            label: getLabel(txn.offlineRadioOptions)?.thirdField
                              .label,
                            placeholder: getLabel(txn.offlineRadioOptions)
                              ?.thirdField.placeholder,
                            required: true,
                            handleOnChange: (e) =>
                              handleInputFilter(
                                e,
                                index,
                                "branchName",
                                "alphabets"
                              ),
                            value: txn.branchName || "",
                            maxLength: 50,
                          }}
                          formik={paymentOptionsFormik}
                        />
                        <FormHelperText error>
                          {paymentOptionsFormik?.touched?.transactions?.[index]
                            ?.branchName
                            ? paymentOptionsFormik?.errors?.transactions?.[
                                index
                              ]?.branchName
                            : ""}
                        </FormHelperText>
                      </Grid>
                    )}
                    {txn.offlineRadioOptions ===
                      OFFLINE_PAYMENT_METHODS.ONLINETRANSFER && (
                      <Grid item xs={12} sm={6}>
                        <TextFieldInput
                          field={{
                            name: `transactions[${index}].accountNo`,
                            label: getLabel(txn.offlineRadioOptions)
                              ?.fourthField.label,
                            placeholder: getLabel(txn.offlineRadioOptions)
                              ?.fourthField.placeholder,
                            required: true,
                            handleOnChange: (e) =>
                              handleInputFilter(
                                e,
                                index,
                                "accountNo",
                                "numbers"
                              ),
                            value: txn.accountNo || "",
                          }}
                          formik={paymentOptionsFormik}
                        />
                        <FormHelperText error>
                          {paymentOptionsFormik?.touched?.transactions?.[index]
                            ?.accountNo
                            ? paymentOptionsFormik?.errors?.transactions?.[
                                index
                              ]?.accountNo
                            : ""}
                        </FormHelperText>
                      </Grid>
                    )} */}

                    <Grid item xs={12} sm={6}>
                      <TextFieldInput
                        field={{
                          name: `transactions[${index}].amount`,
                          label: t("paymentOptionForm.amount"),
                          required: true,
                          placeholder: t("paymentOptionForm.enterAmount"),
                          maxLength: 15,
                          handleOnChange: (e) =>
                            handleInputFilter(e, index, "amount", "numbers"),
                          value: txn.amount || "",
                          readonly: isDisabled,
                        }}
                        formik={paymentOptionsFormik}
                      />
                      <FormHelperText error>
                        {paymentOptionsFormik?.touched?.transactions?.[index]
                          ?.amount
                          ? paymentOptionsFormik?.errors?.transactions?.[index]
                              ?.amount
                          : ""}
                      </FormHelperText>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <CustomDatePicker
                        labelMarginBottom="1px"
                        label={t("paymentOptionForm.transactionDate")}
                        value={
                          paymentOptionsFormik?.values?.transactions?.[index]
                            ?.date
                        }
                        onChange={paymentOptionsFormik?.handleChange}
                        name={`transactions[${index}].date`}
                        error={
                          paymentOptionsFormik?.touched?.transactions?.[index]
                            ?.date &&
                          Boolean(
                            paymentOptionsFormik?.errors?.transactions?.[index]
                              ?.date
                          )
                        }
                        helperText={
                          paymentOptionsFormik?.touched?.transactions?.[index]
                            ?.date
                            ? paymentOptionsFormik?.errors?.transactions?.[
                                index
                              ]?.date
                            : ""
                        }
                        required={true}
                        disabled={isDisabled}
                      />
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      sm={6}
                      className="widthFullUploadInput"
                      sx={{
                        marginTop: "0px",
                      }}
                    >
                      <UploadInput
                        paymentProof={true}
                        index={index}
                        field={{
                          name: "paymentProof",
                          label: t("paymentOptionForm.paymentProofLabel"),
                          required: true,
                          readonly: false,
                          placeholderUpload: t(
                            "paymentOptionForm.paymentProofPlaceholder"
                          ),
                          placeholder: paymentOptionsFormik?.values
                            ?.transactions[index]?.isPhysicalPaymentProof
                            ? "Upload Later"
                            : "Upload Payment Proof",
                          physicalCopyValue:
                            paymentOptionsFormik?.values?.transactions[index]
                              ?.isPhysicalPaymentProof,
                          handleOnClick: () =>
                            toggleTransactionScreenshot(index),
                        }}
                        formik={paymentOptionsFormik}
                        disabled={isDisabled}
                      />
                      <FormHelperText error>
                        {paymentOptionsFormik?.touched?.transactions?.[index]
                          ?.paymentProof
                          ? paymentOptionsFormik?.errors?.transactions?.[index]
                              ?.paymentProof
                          : ""}
                      </FormHelperText>
                    </Grid>
                  </Grid>
                </Box>
              </>
            )}

            {/* Add More Transactions */}
            {values?.transactions?.length - 1 === index &&
              txn.paymentMethod && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "8px",
                    color: "rgba(26, 64, 125, 1)",
                    mt: 1,
                  }}
                >
                  <Button
                    onClick={handleAddTransaction}
                    disabled={
                      (!txn?.isPaid &&
                        txn.paymentMethod === CorporatePaymentMode.GATEWAY) ||
                      paymentOptionsFormik?.values?.transactions?.length >=
                        MAX_TRANSACTION_LIMIT
                    }
                  >
                    <ControlPointIcon
                      sx={{
                        color:
                          (!txn?.isPaid &&
                            txn.paymentMethod ===
                              CorporatePaymentMode.GATEWAY) ||
                          paymentOptionsFormik?.values?.transactions?.length >=
                            MAX_TRANSACTION_LIMIT
                            ? "grey"
                            : "rgba(26, 64, 125, 1)",
                      }}
                    />
                    <Typography
                      sx={{
                        color:
                          (!txn?.isPaid &&
                            txn.paymentMethod ===
                              CorporatePaymentMode.GATEWAY) ||
                          paymentOptionsFormik?.values?.transactions?.length >=
                            MAX_TRANSACTION_LIMIT
                            ? "grey"
                            : "rgba(26, 64, 125, 1)",
                        fontSize: "14px",
                        fontWeight: "600",
                        textDecoration: "underline",
                        textTransform: "none",
                        cursor: "pointer",
                      }}
                    >
                      {t("paymentOptionForm.multipleTransactionButton")}
                    </Typography>
                  </Button>
                </Box>
              )}

            {txn.showUploadPopup && (
              <UploadPopup
                heading={t("paymentOptionForm.uploadPopup")}
                totalImages={1}
                voucherMutliUpload={true}
                closePopup={() => toggleTransactionScreenshot(index)} // ✅ close only this popup
                handleImageValue={(keyName, imgName) =>
                  handleImageValue(index, keyName, imgName, true)
                }
                uploadedImage={
                  paymentOptionsFormik?.values?.transactions[index]
                    ?.paymentProof
                }
                fieldName="paymentProof"
                handleUpdateImageData={(fieldName, imageData) =>
                  handleUpdateImageData(index, fieldName, imageData)
                }
                handlePhysicalImage={(fieldName, value) => {
                  handlePhysicalImage(index, fieldName, value);
                }}
                selectedOptionValue={
                  paymentOptionsFormik?.values?.transactions[index]
                    .isPhysicalPaymentProof
                }
                disabled={isDisabled}
                hidePhysicalCopyOption={true}
              />
            )}
          </Box>
        );
      })}
      <SnackbarAlert
        open={snackbarConfig.open}
        message={snackbarConfig.message}
        severity={snackbarConfig.severity}
        onClose={handleSnackbarClose}
      />
                <PaymentFailedModal
        open={openPaymentFailedModal}
        onClose={handleClosePaymentFailedModal}
        onProceed={handleProceedGateway}
        singleGatewayMode={failedGatewayForRetry != null}
        retryGateway={failedGatewayForRetry}
      />
      
    </>
  );
};

export default CorporatePaymentOptionsForm;